import { getProducts, GetMedicalEquipmentApiParameter } from "@GeriMed/Services/MedicalEquipmentService";
import { CustomerDisplayProductCollection } from "@GeriMed/Type/ApiModelsExt";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";


type HandlerType = ApiHandler<GetMedicalEquipmentApiParameter, CustomerDisplayProductCollection>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const DispatchBeginLoadMedicalEquipmentList: HandlerType = props => {
    props.dispatch({
        type: "Data/MedicalEquipment/BeginLoadMedicalEquipment" as any,
        parameter: props.parameter,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getProducts(props.apiParameter);
};
export const DispatchCompleteLoadMedicalEquipmentList: HandlerType = props => {
    props.dispatch({
        type: "Data/MedicalEquipment/CompleteLoadMedicalEquipment" as any,
        collection: props.apiResult,
        parameter: props.parameter,
    });
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadMedicalEquipmentList,
    RequestDataFromApi,
    DispatchCompleteLoadMedicalEquipmentList,
];

const loadMedicalEquipmentList = createHandlerChainRunner(chain, "loadMedicalEquipmentList");
export default loadMedicalEquipmentList;
